import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function LastName({ index, item }) {

  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Doe</div>
    } else {
      return <>
        <div className="col-8">Last Name</div>
        <div className="col-4">Doe</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>

}